import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { UserdataService } from '../../../service/userdata.service';
import { AppdataService } from '../../../service/appdata.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AvatarEditComponent } from '../../home-header/user-avatar/avatar-edit/avatar-edit.component';
import { smallDialogWidth } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-basic-settings',
    standalone: false,

    templateUrl: './basic-settings.component.html',
    styleUrl: './basic-settings.component.scss'
})
export class BasicSettingsComponent implements AfterViewInit, OnInit, OnDestroy {
    user: any;
    languageOptions: any[] = [];
    routeQueryParams$: Subscription;
    basicForm: FormGroup;

    constructor(
        private userService: UserdataService,
        private appData: AppdataService,
        private fb: FormBuilder,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.userService.data.subscribe((data) => {
            this.user = data;
        });
        this.basicForm = this.fb.group({
            prename: [this.user?.prename],
            lastname: [this.user.lastname],
            lang: [this.user?.lang],
        });
        this.basicForm.valueChanges.subscribe((data) => {
            this.saveChanges('USER');
        });
        this.routeQueryParams$ = this.route.queryParams.subscribe((params) => {
            if (params['edit-avatar']) {
                this.editAvatar();
            }
        });
    }


    ngOnInit(): void {
        this.loadData();
    }
    ngAfterViewInit(): void {
        this.loadData();
    }
    ngOnDestroy(): void {
        this.routeQueryParams$.unsubscribe();
    }
    async saveChanges(type: string) {
        let result = false;
        result = await this.userService.updateUserDataOnServer(this.basicForm.value);
        if (result == true) {
            this.user.prename = this.basicForm.value.prename;
            this.user.lastname = this.basicForm.value.lastname;
            this.user.lang = this.basicForm.value.lang;
            this.userService.updateUserData(this.user);
        }
    }
    changeEmailShow() {
        // open change email dialog
    }
    editAvatar() {
        let result = this.dialog.open(AvatarEditComponent, {
            width: smallDialogWidth,
            panelClass: 'avatar-edit-dialog',
            data: this.user
        });
        result.afterClosed().subscribe((data) => {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { 'edit-avatar': null },
                queryParamsHandling: 'merge'
            });
        });
    }
    async loadData() {
        this.languageOptions = this.appData.systemLanguages;
    }
}

